/**
 * Page-range and spreadsheet-option helpers for the bundle editor.
 */

import { SPREADSHEET_FILE_EXTENSIONS } from '@/constants/supported-file-types';

export const isSpreadsheetBundleExtension = (extension: string): boolean =>
  (SPREADSHEET_FILE_EXTENSIONS as readonly string[]).includes(extension.toLowerCase());

/** Page ranges apply to PDF, Word, and PowerPoint. Images, emails, and spreadsheets are not page-addressable. */
const PAGE_RANGE_SUPPORTED_EXTENSIONS = ['.pdf', '.doc', '.docx', '.ppt', '.pptx'] as const;

export const supportsBundlePageRange = (fileExtension: string): boolean =>
  (PAGE_RANGE_SUPPORTED_EXTENSIONS as readonly string[]).includes(fileExtension.toLowerCase());
